export const tableConfigProspectToday = [
  {
    name: "namaSalesmanCS",
    label: "Nama Salesman/CS",
    options: {
      sort: false,
      setCellProps: () => ({ style: { width: "150px" } }),
    },
  },
  { name: "nonFU", label: "NON FU", options: { sort: false } },
  { name: "ongoing", label: "ONGOING", options: { sort: false } },
  { name: "pending", label: "PENDING", options: { sort: false } },
];

export const CONFIG_REPORT_STATISTIC_PROSPECT_TODAY = [
  { name: "namaSalesmanCS", label: "Nama Salesman/CS", options: { sort: false } },
  { name: "namaKonsumen", label: "Nama Konsumen", options: { sort: false } },
  { name: "alamat", label: "Alamat", options: { sort: false } },
  { name: "kecamatan", label: "Kecamatan", options: { sort: false } },
  { name: "noHape1", label: "No Hape 1", options: { sort: false } },
  { name: "noHape2", label: "No Hape 2", options: { sort: false } },
];

export const tableConfigAppointmentOverdue = [
  ...CONFIG_REPORT_STATISTIC_PROSPECT_TODAY,
  { name: "overdue", label: "Overdue", options: { sort: false } },
];

export const SAMPLE_DATA_STATISTIC_PROSPECT_TODAY = [
    {salesmanName: "John Doe", nonFU: 5, ongoing: 3, pending: 2},
    {salesmanName: "Jane Smith", nonFU: 4, ongoing: 2, pending: 1},
    {salesmanName: "Bob Johnson", nonFU: 6, ongoing: 4, pending: 3},
    {salesmanName: "Alice Brown", nonFU: 7, ongoing: 5, pending: 4},
    {salesmanName: "Charlie Davis", nonFU: 8, ongoing: 6, pending: 5},
]

export const SAMPLE_DATA_REPORT_STATISTIC_PROSPECT_TODAY = [
  { salesmanName: "John Doe", consumenName: "Jane Smith", address: "123 Main St", kecamatan: "Central", noHp1: "1234567890", noHp2: "0987654321" },
  { salesmanName: "Alice Brown", consumenName: "Bob Johnson", address: "456 Elm St", kecamatan: "North", noHp1: "2345678901", noHp2: "9876543210" },
  { salesmanName: "Charlie Davis", consumenName: "Eve White", address: "789 Oak St", kecamatan: "South", noHp1: "3456789012", noHp2: "8765432109" },
];

export const SAMPLE_DATA_REPORT_APPOINTMENT_OVERDUE = SAMPLE_DATA_REPORT_STATISTIC_PROSPECT_TODAY.map((item) => ({...item,overdue:Math.ceil(Math.random()* 10)}));